import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Label from '../../base/label/components/web/Label';
import Tooltip from '../../base/tooltip/components/Tooltip';
const TranscribingLabel = () => {
    const _showLabel = useSelector((state) => state['features/transcribing'].isTranscribing);
    const { t } = useTranslation();
    if (!_showLabel) {
        return null;
    }
    return (React.createElement(Tooltip, { content: t('transcribing.labelToolTip'), position: 'left' },
        React.createElement(Label, { className: 'recording-label', text: t('transcribing.tr') })));
};
export default TranscribingLabel;
